<!--
 * @Description: 销售范围
 * @Autor: txp
 * @Date: 2021-04-07 10:54:47
-->
<template>
    <div class="canshopCar">
        <div class="title">{{names}}</div>
         <div class="content">
            <el-row type="flex" class="row-bg">
                <el-col class="flex" :span="24">
                    <div class="grid-content">包含:</div>
                    <div class="bg-purple">
                        <el-table
                           :header-cell-style="{ textAlign: 'center',fontSize:'13px',color:'#787878',background:'#F5F5F5'}"
                            :cell-style="{textAlign:'center',fontSize:'14px',color:'#1D1D1D'}"
                            :data="tableData"
                            style="width: 100%">
                            <el-table-column
                                prop="country"
                                label="国家">
                            </el-table-column>
                            <el-table-column
                                prop="province"
                                label="省">
                            </el-table-column>
                            <el-table-column
                                prop="city"
                                label="市">
                            </el-table-column>
                            <el-table-column
                                prop="district"
                                label="区">
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
            </el-row>
            <el-row type="flex" class="row-bg">
                <el-col class="flex" :span="24">
                    <div class="grid-content">非包含:</div>
                    <div class="bg-purple">
                         <el-table
                           :header-cell-style="{ textAlign: 'center',fontSize:'13px',color:'#787878',background:'#F5F5F5'}"
                            :cell-style="{textAlign:'center',fontSize:'14px',color:'#1D1D1D'}"
                            :data="tableData1"
                            style="width: 100%">
                            <el-table-column
                                prop="country"
                                label="国家">
                            </el-table-column>
                            <el-table-column
                                prop="province"
                                label="省">
                            </el-table-column>
                            <el-table-column
                                prop="city"
                                label="市">
                            </el-table-column>
                            <el-table-column
                                prop="district"
                                label="区">
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
            </el-row>
         </div>
    </div>
</template>
<script>
export default {
    name:'canshopCar',
    data(){
        return{
            tableData: [],
            tableData1: []
        }
    },
    props:['dataLists','names'],
    created(){
        this.tableDataList()
    },
    methods:{
        tableDataList(){
           let list =  this.dataLists[0].voList || []
           if(list.length>0){
               for(let i=0;i<list.length;i++){
                   if(list[i].containFlag == 1){
                       this.tableData.push(list[i])
                   }else{
                        this.tableData1.push(list[i])
                   }
               }
           }
        }
    }
}
</script>
<style lang="scss" scoped>
    .canshopCar{
        margin: 20px 0px;
        border-bottom: 1px solid $color-primary;
        .title{
            font-size: 18px;
            font-weight: 600;
            border-left: 9px solid $color-primary;
            padding-left: 9px;
            margin-bottom: 20px;
            height: 18px;
            line-height: 18px;
        }
        .content{
            padding: 20px;
            /deep/ .el-row {
                .el-col{
                    border-radius: 4px;
                    line-height: 30px;
                    margin-top: 10px;
                }
                .grid-content{
                    width: 130px;
                    text-align: right;
                    padding-right: 10px;
                    box-sizing: border-box;
                    font-size: 13px;
                    color: #666666;
                }
                .bg-purple{
                    line-height: 30px;
                    font-size: 13px;
                    color: #666666;
                    background: #eee;
                    min-height: 30px;
                    flex: 1;
                    border-radius: 6px
                }
                
            }
        }
    }
</style>

